import Vue from 'vue';
import moment from 'moment';

export const centsToDollars = (value?:number):string => {
  if (value == null || value == undefined) return ''
  try {
    return '$' + ((value / 100).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  } catch(error) {
    console.error(value, error);
    return value.toString();
  }
}

export const unixToDate = (value?:number):string => {
  if (value == null || value == undefined) return ''
  try {
    return moment.utc(new Date(value * 1000)).format('MM/DD/YYYY');
  } catch(error) {
    console.error(value, error);
    return value.toString();
  }
}

export const unixToDateTime = (value?:number):string => {
  if (value == null || value == undefined) return ''
  try {
    return moment.utc(new Date(value * 1000)).format("MM/DD/YYYY @ hh:mm a z");
  } catch(error) {
    console.error(value, error);
    return value.toString();
  }
}

export const month = (value?:number):string => {
  if (value == null || value == undefined) return ''
  try {
    return moment.utc(value, 'M').format('MMMM');
  } catch(error) {
    console.error(value, error);
    return value.toString();
  }
}

export const commifyNumber = (value:number):string => {
  if (value == null || value == undefined) return ''
  // This accounts for more than 3 digits after a decimal. We don't want commas there.
  let parts = value.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export const percentage = (value:number):string => {
  if (value == null || value == undefined || value == 0) return ''
  try {
    return parseFloat(value.toString()).toFixed(2) + '%'
  }
  catch(error) {
    console.error(value, error);
    return value.toString();
  }
}

export const absoluteVal = (value:number):string => {
  if (value == null || value == undefined) return ''
  try {
    return Math.abs(value).toString();
  }
  catch(error) {
    console.error(value, error);
    return value.toString();
  }
}

export const timeFromNow = (value:number):string => {
  if (value == null || value == undefined) return ''
  try {
    return moment.unix(value).fromNow();
  }
  catch(error) {
    console.error(value, error);
    return value.toString();
  }
}

export const timeRelativeRecent = (value:number):string => {
  if (value == null || value == undefined) return ''
  try {
    const now = (new Date()).getTime()
    if (now - (value * 1000) > 86400000) { // over a day ago
      return moment.utc(new Date(value * 1000)).format("MM/DD/YYYY");
    } else {
      return moment.unix(value).fromNow();
    }
  }
  catch(error) {
    console.error(value, error);
    return value.toString();
  }
}

export function AddFilters(app: Vue.App) {
  app.config.globalProperties.$filters = {
    ...app.config.globalProperties.$filters,
    centsToDollars,
    unixToDate,
    unixToDateTime,
    commifyNumber,
    percentage,
    absoluteVal,
    timeFromNow,
    timeRelativeRecent,
    month
  }
}
